<template>
    <div class="vld-parent" v-if="View_acce">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["NO"]}}
                                            </template>
                                            <template v-else-if="header == 'BN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["DB"]["BN"]}}
                                                <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['DB']['A']}}
                                                <i @click="setSortTable('AC')" :class="setSortLogo('AC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'U'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["DB"]["MUN"]}}
                                                <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["DB"]["TA"]}}
                                                <i @click="setSortTable('A')" :class="setSortLogo('A')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'T'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['DB']['T']}}
                                                <i @click="setSortTable('T')" :class="setSortLogo('T')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'RB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['DB']['RB']}}
                                                <i @click="setSortTable('RB')" :class="setSortLogo('RB')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TSID'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                <span style="color: darkorange; font-weight: bold;">{{getLanguage['MEM']['TSID']}}</span> /
                                                <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span>
                                            </template>
                                            <template v-else-if="header == 'AB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['DB']['OP']}}
                                                <i @click="setSortTable('AB')" :class="setSortLogo('AB')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'ATS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['DT']}}
                                                <i @click="setSortTable('ATS')" :class="setSortLogo('ATS')" class="sortlogo"></i>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SMB"]["DMMAL"]}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="/src/assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <div class="inline">
                                    <div class="d-flex">
                                        <input type="checkbox" v-model="searchExcludeSubAgent" id="searchExcludeSubAgent" />
                                        <label class="searchLabel ml-1" for="searchExcludeSubAgent">{{getLanguage["GL"]["ODA"]}}</label>
                                    </div>
                                </div>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroup"
                                                  :defaultExpandLevel="Infinity"
                                                  :flat="true"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  class="searchdashboard"
                                                  @input="AgentGroupChangefs"
                                                  v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="searchSubAgent"
                                            openDirection="below"
                                            :disabled="searchExcludeSubAgent"
                                            class="searchdashboard" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MTA"]["C"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_currency"
                                            :placeholder="this.utilGetDDLanguage('MTA.C')"
                                            class="searchdashboard"
                                            v-model="searchCurrency" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['DB']['T']}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_activityType"
                                            :placeholder="this.utilGetDDLanguage('DB.T')"
                                            class="searchdashboard"
                                            v-model="searchActivityType" />
                            </div>
                        </div>


                        <div class='searchBtnCol'>
                            <button type="button" class="btn searchBtn btn-success btn-sm btn-block" style="background: #6f6bd6;border: #6f6bd6" @click="nextGetUpdate(true, true, true)"><span class="searchIcon cil-search"></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></button>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>

        <div v-if="bool_showDetails">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="mb-0">Transaction Details</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_showDetails = !bool_showDetails">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div>
                                        <table class="custom-table custom-table-inPopUp afb-blue">
                                            <thead>
                                                <tr>
                                                    <th style="width: 25%;">{{this.getLanguage["DB"]["T"]}}</th>
                                                    <th style="width: 25%;">{{this.getLanguage['MTA']['MUN']}}</th>
                                                    <th style="width: 25%;" class="tableCtnRight">{{this.getLanguage['MTA']['TA']}}</th>
                                                    <th style="width: 25%;">{{this.getLanguage['DB']['BN']}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr :class="obj_details.MS == 1? 'blacklist-row': ''">
                                                    <td>
                                                        <span class="grid-line">{{ renderActivityType(obj_details.T) }}</span>
                                                        <span class="grid-line">{{ obj_details.DA }}</span>
                                                    </td>
                                                    <td>{{ obj_details.U }}</td>
                                                    <td class="tableCtnRight">{{ formatNumber(obj_details.A, 2, obj_details.CS) }}</td>
                                                    <td>
                                                        <span class="grid-line">{{ obj_details.GN }} ({{ obj_details.GPC }})</span>
                                                        <span class="grid-line">{{ obj_details.DN }}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="mt-3">
                                        <table class="custom-table custom-table-inPopUp afb-blue">
                                            <thead>
                                                <tr>
                                                    <th style="width: 10%;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                    <th style="width: 30%;">{{this.getLanguage['DB']['A']}}</th>
                                                    <th style="width: 30%;">{{this.getLanguage['DB']['OP']}}</th>
                                                    <th style="width: 30%;">{{this.getLanguage['GL']['DT']}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(data,index) in arry_details" :class="data.MS == 1? 'blacklist-row': ''">
                                                    <td>{{ CountItem(index+1) }}</td>
                                                    <td>
                                                        <span class="grid-line">{{ renderActionLog(data.AC) }}</span>
                                                        <span class="grid-line rejectReason" v-if="data.AC==3">{{ renderRejectReason(data.RR , data.T) }}</span>
                                                    </td>
                                                    <td>
                                                        <div v-if="data.ABPC!=''">{{ data.AB }} ({{ data.ABPC }})</div>
                                                        <div v-else>-</div>
                                                    </td>
                                                    <td>{{ formatDateTime(data.ATS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <!-- user activity table -->
        <div class="container-fluid">
            <div class='table-wrapper' style="margin: 0;">
                <header class="table-header">
                    <div>
                        <!--<div id="dashboardmonitoring" :class="setCollapseExpandIcon()" @click="toggleDashboardMonitoringList($event)" ></div>-->
                        <strong>{{this.getLanguage['SMB']['DMMAL']}}</strong>
                    </div>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class="custom-table afb-blue">
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["NO"]}}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["DB"]["BN"]}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DB']['A']}}
                                        <i @click="setSortTable('AC')" :class="setSortLogo('AC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["DB"]["MUN"]}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["DB"]["TA"]}}
                                        <i @click="setSortTable('A')" :class="setSortLogo('A')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'T'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DB']['T']}}
                                        <i @click="setSortTable('T')" :class="setSortLogo('T')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'RB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DB']['RB']}}
                                        <i @click="setSortTable('RB')" :class="setSortLogo('RB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TSID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <span style="color: darkorange; font-weight: bold;">{{getLanguage['MEM']['TSID']}}</span> /
                                        <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span>
                                    </template>
                                    <template v-else-if="header == 'AB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DB']['OP']}}
                                        <i @click="setSortTable('AB')" :class="setSortLogo('AB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ATS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['DT']}}
                                        <i @click="setSortTable('ATS')" :class="setSortLogo('ATS')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class="custom-table afb-blue" style="min-height: 150px;">
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["NO"]}}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["DB"]["BN"]}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DB']['A']}}
                                        <i @click="setSortTable('AC')" :class="setSortLogo('AC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["DB"]["MUN"]}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["DB"]["TA"]}}
                                        <i @click="setSortTable('A')" :class="setSortLogo('A')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'T'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DB']['T']}}
                                        <i @click="setSortTable('T')" :class="setSortLogo('T')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'RB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['RB']}}
                                        <i @click="setSortTable('RB')" :class="setSortLogo('RB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TSID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <span style="color: darkorange; font-weight: bold;">{{getLanguage['MEM']['TSID']}}</span> /
                                        <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span>
                                    </template>
                                    <template v-else-if="header == 'AB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DB']['OP']}}
                                        <i @click="setSortTable('AB')" :class="setSortLogo('AB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ATS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['DT']}}
                                        <i @click="setSortTable('ATS')" :class="setSortLogo('ATS')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                            <td colspan="100%" v-if=" arry_ural.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                            <tr v-for="(data,index) in arry_ural" :class="data.MS == 1? 'blacklist-row': ''">
                                <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                    <template v-if="header == 'NO'">
                                        {{ CountItem(index+1) }}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span>
                                        <span class="saggroupname" v-if="data.SAGPC != ''">{{ data.SAGGN }} ({{ data.SAGPC }})</span>
                                        <span class="grid-line">{{ data.DN }}</span>
                                    </template>
                                    <template v-else-if="header == 'AC'">
                                        <span v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="showDetails(data)">
                                            <span class="grid-line">{{ renderActionLog(data.AC) }}</span>
                                            <span class="grid-line rejectReason" v-if="data.AC==3" style="color:red">{{ renderRejectReason(data.RR , data.T) }}</span>
                                        </span>
                                        <span v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                            <span class="grid-line">{{ renderActionLog(data.AC) }}</span>
                                            <span class="grid-line rejectReason" v-if="data.AC==3" style="color:red">{{ renderRejectReason(data.RR , data.T) }}</span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <div v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="CheckingMember(data.AGI,data.MI)">
                                            <div class="custom-tooltip">
                                                <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                                <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                            </div>
                                            <div class="custom-tooltip" v-if="data.TW == 0">
                                                <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                                <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                            </div>
                                            <div class="custom-tooltip" v-if="data.HTWT">
                                                <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                                <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                            </div>
                                            <div class="custom-tooltip" v-if="data.RP">
                                                <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                                <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                            </div>
                                            <div class="float-right ml-1">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16" >
                                                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                                </svg>
                                            </div>
                                        </div>
                                        <div v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                            <div class="custom-tooltip">
                                                <span :style="getbgtooltip(data)">{{data.U}}</span>
                                                <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                            </div>
                                            <div class="custom-tooltip" v-if="data.TW == 0">
                                                <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                                <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                            </div>
                                            <div class="custom-tooltip" v-if="data.HTWT">
                                                <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                                <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                            </div>
                                            <div class="custom-tooltip" v-if="data.RP">
                                                <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                                <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                            </div>
                                            <div class="float-right ml-1">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16" >
                                                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else-if="header == 'TA'">
                                        <span :style="renderStatusStyle(data.T, data.AC)" class="grid-line">{{ formatNumber(data.A, 2, data.CS) }}</span>
                                        <!-- <span :style="renderStatusStyle(data.T, data.AC)" class="grid-line">{{ data.R }}</span>-->
                                    </template>
                                    <template v-else-if="header == 'T'">
                                        <span class="grid-line" :style="renderActivityStyle(data.T, data.AC)">{{ renderActivityType(data.T) }}</span>
                                        <span class="grid-line" :style="renderActivityStyle(data.T, data.AC)">{{ data.DA }}</span>
                                    </template>
                                    <template v-else-if="header == 'RB'">
                                        <span class="grid-line remarkwidth">{{ data.R }}</span>
                                    </template>

                                    <template v-else-if="header == 'TSID'">
                                        <div v-if="getUserInfo.AT!=4">
                                            <span style="text-align:center;display:block">
                                                <span v-if="data.TSI > 0 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="getSystemId(data)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                    <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TMEM }})</span>
                                                </span>
                                                <span v-else-if="data.TSI > 0 && isSENS == 1 && data.AGI != curAGI" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                    <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TMEM }})</span>
                                                </span>
                                                <span class="grid-line" v-else>-</span>
                                                <table class='p-4 mt-2' v-if="opened.includes(data.I)" style="width: 100%; background: #ebedef">
                                                    <thead>
                                                        <tr>
                                                            <th>{{ getLanguage['LOGRPT']['SI'] }}</th>
                                                            <th>{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(row,index1) in arry_systemId[data.I]">
                                                            <tr style="text-align: left;">
                                                                <td :style="[row.MI>0?{'cursor':'pointer'}:{}]" @click="row.MI>0?toggleFingPrintId(row,index,index1):{}" :class="{opened: opened.includes(index+'_'+index1)}">{{ row.SI }} <span style="color:red" v-if="row.MI>0">({{row.MI}})</span></td>
                                                                <td>{{ formatDateTime(row.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                            </tr>
                                                            <tr v-if="opened.includes(index+'_'+index1)" style="background: darkred">
                                                                <td colspan="2" style="padding:2px">
                                                                    <table class='p-4' style="width: 100%; background: #ebedef;margin-top:1px">
                                                                        <thead>
                                                                            <tr>
                                                                                <th style="background: darkgoldenrod;padding:0.25rem">{{getLanguage['GL']['NO']}}</th>
                                                                                <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['ACC'] }}</th>
                                                                                <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(item,index) in arry_visitorMembers[index+'_'+index1]" style="text-align:left">
                                                                                <td style="text-align:center">{{ CountItem(index+1) }}</td>
                                                                                <td>
                                                                                    <router-link :to="{ path:'/M/MCMI', query:{ agi: item.AGI, i: item.MI, u: item.UB, cf: 7}}" target="_blank">{{ item.UB }}</router-link>
                                                                                </td>
                                                                                <td style="text-align: right;">{{ formatDateTime(item.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </span>
                                        </div>
                                        <div v-if="getUserInfo.AT==4">
                                            <!--sub agent view this section-->
                                            <span style="text-align:center;display:block">
                                                <span v-if="data.SUBATSI > 0 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="getSystemId(data)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                    <span style="color:darkorange">({{ data.SUBATSI }})</span> / <span style="color:red">({{ data.SUBATM }})</span>
                                                </span>
                                                <span v-else-if="data.SUBATSI > 0 && isSENS == 1 && data.AGI != curAGI" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                    <span style="color:darkorange">({{ data.SUBATSI }})</span> / <span style="color:red">({{ data.SUBATM }})</span>
                                                </span>
                                                <span class="grid-line" v-else>-</span>
                                                <table class='p-4 mt-2' v-if="opened.includes(data.I)" style="width: 100%; background: #ebedef">
                                                    <thead>
                                                        <tr>
                                                            <th>{{ getLanguage['LOGRPT']['SI'] }}</th>
                                                            <th>{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(row,index1) in arry_systemId[data.I]">
                                                            <tr style="text-align: left;">
                                                                <td :style="[row.MI>0?{'cursor':'pointer'}:{}]" @click="row.MI>0?toggleFingPrintId(row,index,index1):{}" :class="{opened: opened.includes(index+'_'+index1)}">{{ row.SI }} <span style="color:red" v-if="row.MI>0">({{row.MI}})</span></td>
                                                                <td>{{ formatDateTime(row.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                            </tr>
                                                            <tr v-if="opened.includes(index+'_'+index1)" style="background: darkred">
                                                                <td colspan="2" style="padding:2px">
                                                                    <table class='p-4' style="width: 100%; background: #ebedef;margin-top:1px">
                                                                        <thead>
                                                                            <tr>
                                                                                <th style="background: darkgoldenrod;padding:0.25rem">{{getLanguage['GL']['NO']}}</th>
                                                                                <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['ACC'] }}</th>
                                                                                <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(item,index) in arry_visitorMembers[index+'_'+index1]" style="text-align:left">
                                                                                <td style="text-align:center">{{ CountItem(index+1) }}</td>
                                                                                <td>
                                                                                    <router-link :to="{ path:'/M/MCMI', query:{ agi: item.AGI, i: item.MI, u: item.UB, cf: 7}}" target="_blank">{{ item.UB }}</router-link>
                                                                                </td>
                                                                                <td style="text-align: right;">{{ formatDateTime(item.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </span>
                                        </div>

                                    </template>

                                    <template v-else-if="header == 'AB'">
                                        <div v-if="data.ABPC!=''">{{ data.AB }} ({{ data.ABPC }})</div>
                                        <div v-else>{{ data.AB }}</div>
                                    </template>
                                    <template v-else-if="header == 'ATS'">
                                        {{ formatDateTime(data.ATS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                    </template>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "../modules/GenericHelper.js";
    import moment from 'moment'
    import Loading from 'vue-loading-overlay';
    import { constRejectReasonP, constRejectReasonD, constRejectReasonW, loadingFullScreen } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import { constAccessType } from '@/modules/Constant.js';
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import VueApexCharts from 'vue-apexcharts'
    import Vue from 'vue'
    import $ from 'jquery'
    import draggable from 'vuedraggable';

    Vue.use(VueApexCharts)
    Vue.component('apexchart', VueApexCharts)

    export default {
        mixins: [genericHelper],
        computed: {
            ...mapGetters('UserInfo', ['getUserInfo']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'checkModuleIndex']),
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('DashboardData', [
                'getPendingDeposit',
                'getPendingWithdrawal',
                'getPendingPromotion'
            ]),
            ...mapGetters('SMBData', [
                'getCurrencyCode'
            ]),
        },
        name: 'MemberActivitiesList',
        components: {
            Loading,
            Treeselect,
            customtreeselect,
            DateRangePicker,
            draggable
        },

        data() {
            return {
                visible: false,
                bool_fullLoading: false, //Loading Visible
                bool_showDetails: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                bool_fingerPrintLoading: [], // fingerprint/lastSystemID
                opened: [],
                arry_visitorMembers: [],
                arry_systemId: [],
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_TP: 1, //Total Page
                str_tableSortBy: "ATS", //(sort the table col name)
                bool_isSort: true,
                bool_firstLogin: false,
                bool_firstsearchAgent: false,
                arry_ural: [], // user recent activity list
                dd_agentgroup: [],//agent group option
                dd_subagentgroup: [],//subagent group option
                ddDefaultSubBrand: [],//subagent default group option
                dd_currency: [],
                dd_currency1: [],
                obj_details: {},
                arry_details: [],
                showChart: "",
                SummaryArray: [],
                searchAgent: null,
                searchSubAgent: null,
                searchCurrency: null,
                convertCurrency: null,
                searchActivityType: null,
                dd_activityType: [],
                setMemberOnline: 0,
                setMemberOnline_DESKTOP: 0,
                setMemberOnline_MOBILE: 0,
                setMemberOnline_ANDROID: 0,
                setMemberOnline_IOS: 0,
                setTotalMember: 0,
                arry_memberOnlineSource: [],
                arry_memberOnline: [],
                array_monthlyRS: [],
                array_dailyRS: [],
                AutoGetUpdateTO: null,
                AutoUpdateTO: null,
                rtSubBrand: 0,//subagent dd refresh key
                DB_Month: "",
                DB_TDay: "",
                DB_CDay: "",
                DB_DProgress: "",
                DB_DRefresh: "-",

                MTD_Deposit: 0, // Month to Date
                L_MTD_Deposit: 0, // Month to Date
                MTD_Withdraw: 0,
                L_MTD_Withdraw: 0,
                MTD_Register: 0,
                L_MTD_Register: 0,
                AMT_MTD_Bonus: 0,
                AMT_MTD_DLS: 0,
                AMT_MTD_AR: 0,
                AMT_MTD_AFF: 0,
                AMT_MTD_TNMT: 0,
                AMT_MTD_BonusC: 0,
                AMT_Y_Deposit: 0,
                AMT_Y_Withdraw: 0,

                D_Deposit: 0, // Day
                D_Withdraw: 0,
                D_Register: 0,
                D_DailyFirstDeposit: 0,
                D_ActiveMember: 0,

                CD_Deposit: [], // Chart
                CD_Register: [],
                CD_DepositMoney: [],

                Y_Deposit: 0, // Yesterday
                Y_Withdraw: 0,

                View_acce: false,

                AMT_MTD_Deposit: 0, // Deposit Amount
                AMT_LMTD_Deposit: 0, // Deposit Amount
                AMT_MTD_Withdraw: 0, // Withdraw Amount
                AMT_LMTD_Withdraw: 0, // Withdraw Amount

                AMT_D_Deposit: 0, // Deposit Amount
                AMT_D_Withdraw: 0, // Withdraw Amount
                AMT_D_Bonus: 0,//Bonus
                AMT_D_AR: 0,//Auto Rebate
                AMT_D_DLS: 0,//Daily Lucky Spin
                AMT_D_Aff: 0,//Affiliate
                AMT_D_TNMT: 0,//Tournament

                AMT_Y_Bonus: 0,

                AMT_D_PNL: 0, // Day P & L Amount
                AMT_Y_PNL: 0, // Yesterday P & L Amount

                AMT_MTD_PNL: 0, // Month to Date P & L Amount
                AMT_LMTD_PNL: 0, // Last Month to Date P & L Amount

                AMT_LMTD_NPNL: 0, // Last Month to Date Net P & L Amount

                CurrencySymbolShow: "",

                top3b: [],
                bottom3b: [],

                constAccessType: constAccessType,
                chartOptions: {
                    colors: ['#4CD174', '#312D8D', '#ff1919'],
                    //colors: ['#30878E', '#6D6BA3', '#f0ab4a'],
                    //stroke: {
                    //    width: 2,
                    //},
                    //chart: {
                    //    toolbar: {
                    //        tools: {
                    //            download: true,
                    //            selection: false,
                    //            zoom: false,
                    //            zoomin: false,
                    //            zoomout: false,
                    //            pan: false,
                    //            reset: false | '<img src="/static/icons/reset.png" width="20">',
                    //            customIcons: [{
                    //                icon: '<img src="/Content/img/excel.png" width="20" style="padding-left:2px">',
                    //                index: 0,
                    //                title: 'Download Excel',
                    //                class: 'custom-icon',
                    //                click: function (chart, options, e) {
                    //                    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                    //                    var m = new Date();
                    //                    var data = months[m.getMonth()];
                    //                    data += "_x_" + options.config.series[0].data.toString();
                    //                    data += "_x_" + options.config.series[1].data.toString();
                    //                    //data += "_x_" + options.config.series[2].data.toString();
                    //                    window.open(`/api/dc/graphexcel?data=${data}`, '_blank');
                    //                }
                    //            }]
                    //        },
                    //        export: {
                    //            csv: {
                    //                filename: 'RegisterMemberAndDepositOverview' + this.getCurrentMonth(),
                    //                headerCategory: 'Date',
                    //            },
                    //            svg: {
                    //                filename: 'RegisterMemberAndDepositOverview'
                    //            },
                    //            png: {
                    //                filename: 'RegisterMemberAndDepositOverview'
                    //            }
                    //        }
                    //    },
                    //},
                    xaxis: {
                        categories: [],
                        type: 'category',
                        tickPlacement: 'on',
                        labels: {
                            show: true,
                            hideOverlappingLabels: false
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                            return value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                        },
                        style: {
                            fontSize: '10px',
                        }
                    },
                    savedata: [
                        {
                            name: "Deposit-Money",
                            data: []
                        },
                    ],
                    tooltip: {
                        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                            if (seriesIndex == 0) { //Deposit-Count
                                return (
                                    '<div class="apextooltip_box text-left p-2">' +
                                    '<span>' +
                                    'Deposit - Count' +
                                    ': ' +
                                    series[seriesIndex][dataPointIndex].toLocaleString('en-US', { minimumFractionDigits: 0 }) +
                                    '</span>' +
                                    '</br>' +
                                    '<span>' +
                                    'Deposit - Amount' +
                                    ': ' +
                                    (Math.round(w.config.savedata[0].data[dataPointIndex] * 100) / 100).toLocaleString('en-US', { minimumFractionDigits: 2 }) +
                                    '</span>' +
                                    '</div>'
                                )
                            }
                            else if (seriesIndex == 1) {
                                return (
                                    '<div class="apextooltip_box text-left p-2">' +
                                    '<span>' +
                                    'Registered - Count' +
                                    ': ' +
                                    series[seriesIndex][dataPointIndex].toLocaleString('en-US', { minimumFractionDigits: 0 }) +
                                    '</span>' +
                                    '</div>'
                                )
                            }
                            else if (seriesIndex == 2) {
                                return (
                                    '<div class="apextooltip_box text-left p-2">' +
                                    '<span>' +
                                    'Active Member - Count' +
                                    ': ' +
                                    series[seriesIndex][dataPointIndex].toLocaleString('en-US', { minimumFractionDigits: 0 }) +
                                    '</span>' +
                                    '</div>'
                                )
                            }

                        }
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                orientation: 'vertical',
                                position: 'center' // bottom/center/top
                            }
                        }
                    },
                },
                series: [
                    {
                        name: "Deposit-Count",
                        type: 'column',
                        data: []
                    },
                    {
                        name: "Registered-Count",
                        type: 'column',
                        data: []
                    }
                    //,
                    //{
                    //    name: "Active Member-Count",
                    //    type: 'line',
                    //    data: []
                    //},
                ],

                //bool_ajaxloading: {
                //    userActivityList: false,
                //    dashboardDataList: false
                //},
                //bool_showDashboardMonitoring: true,
                str_loadText: "",
                defaultReportHeaders: ['NO', 'BN', 'AC', 'U', 'TA', 'T', 'RB', 'TSID', 'AB', 'ATS'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
                searchExcludeSubAgent: false
            }
        },

        methods: {
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                //this.bool_ajaxloading.userActivityList = false;
                this.getUserActivityList(true, true);
            },
            color(value) {
                let $color
                if (value <= 25) {
                    $color = 'info'
                } else if (value > 25 && value <= 50) {
                    $color = 'success'
                } else if (value > 50 && value <= 75) {
                    $color = 'warning'
                } else if (value > 75 && value <= 100) {
                    $color = 'danger'
                }
                return $color
            },
            showDetails(data) {
                this.arry_details = [];
                this.bool_fullLoading = true;
                this.obj_details = Object.assign(this.obj_details, data);

                var that = this;
                var path = this.getListingParamQuery(1, 20, "AS", true);
                path += ("&f[MPTI]=" + data.MPTI + "&f[ID]=0" + "&f[T]=" + data.T);

                this.getDataApi(`/api/dc/urah?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.arry_details = d.D.Items
                            that.bool_showDetails = true;
                        }
                    });
            },
            getUserActivityList(isLoading = false, isScroll = false) {
                //if (!this.bool_showDashboardMonitoring)
                //    return;
                //if (isLoading) {
                //    //this.bool_ajaxloading.userActivityList = false;
                //}
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                var agi = null;
                if (this.searchSubAgent != null) {
                    agi = this.searchSubAgent;
                }
                else {
                    if (this.searchAgent != null)
                        agi = this.searchAgent.split("-")[1];
                }

                //if (this.searchAgent != null) {
                //    agi = this.searchAgent.split("-")[1];
                //}

                path += ("&f[ID]=1" + "&f[CI]=" + this.searchCurrency + '&f[AGI]=' + agi + '&f[EXSAG]=' + this.searchExcludeSubAgent + '&f[T]=' + (this.searchActivityType ? this.searchActivityType : ''));

                this.getDataApi(`/api/dc/ural?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        //that.bool_ajaxloading.userActivityList = false;
                        that.str_loadText = that.getLanguage["GL"]["NR"]
                        if (s) {
                            that.setUserActivityList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setUserActivityList(data) {
                this.arry_ural = data.Items;                
                this.int_TP = Math.max(data.TotalPages, 1);                                
                this.int_TI = data.TotalItems;
            },
            CountItem(value) {
                if (this.int_Page > 1 && this.int_Page < this.int_TP) {
                    return value + ((this.int_Page - 1) * this.int_RC);
                } else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getUserActivityList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            renderActivityType(type) {
                return this.getLanguage['DB']['T' + type];
            },
            renderActivityStyle(Activitytype, Actiontype) {
                if (Activitytype == 2 && Actiontype == 2) {
                    return { 'font-weight': 'bold', color: '#e53636' };
                }
                else if (Activitytype == 1 && Actiontype == 2) {
                    return { 'font-weight': 'bold', color: '#256c72' };
                }
                else if (Activitytype == 3 && Actiontype == 2) {
                    return { 'font-weight': 'bold', color: '#6f6bd6' };
                }
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.searchPAgi = agi;
                    } else {
                        this.searchPAgi = 0;
                    }

                } else {
                    this.searchPAgi = 0;
                    this.searchAgent = null;
                }
                this.searchCurrency = null;
                this.dd_currency = null;
                this.getCurrencyList();
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                                var at = 0;
                                at = that.dd_agentgroup[0].id.split("-")[0];
                                if (at == 3 && that.dd_agentgroup.length < 2) {
                                    that.searchAgent = that.dd_agentgroup[0].id;
                                }
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            renderStatusStyle(Activitytype, Actiontype) {
                if (Activitytype == 2 && Actiontype == 2) {
                    return { 'font-weight': 'bold', color: '#e53636' };
                }
                else if (Activitytype == 1 && Actiontype == 2) {
                    return { 'font-weight': 'bold', color: '#256c72' };
                }
                else if (Activitytype == 3 && Actiontype == 2) {
                    return { 'font-weight': 'bold', color: '#6f6bd6' };
                }
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            renderActionLog(actionCode) {
                return this.getLanguage['DB']['AC' + actionCode];
            },
            renderBrandName(GN, GPC) {
                return GN + " (" + GPC + ")";
            },
            renderRejectReason(rejectReason, Activitytype) {

                if (Activitytype == 1) {
                    const found = constRejectReasonD.some(el => el.id === rejectReason);

                    if (found) {
                        for (var d of constRejectReasonD) {
                            if (d.id == rejectReason) {
                                rejectReason = d.label;
                            }
                        }
                    }

                    return rejectReason;
                }
                else if (Activitytype == 2) {
                    const found = constRejectReasonW.some(el => el.id === rejectReason);

                    if (found) {
                        for (var d of constRejectReasonW) {
                            if (d.id == rejectReason) {
                                rejectReason = d.label;
                            }
                        }
                    }

                    return rejectReason;
                }
                else if (Activitytype == 3) {
                    const found = constRejectReasonP.some(el => el.id === rejectReason);

                    if (found) {
                        for (var d of constRejectReasonP) {
                            if (d.id == rejectReason) {
                                rejectReason = d.label;
                            }
                        }
                    }

                    return rejectReason;
                }
            },
            format_date(value) {
                if (value) {
                    return moment(String(value)).format('DD MMM YYYY')
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.searchAgent && this.searchAgent != 'dummy') {
                    var agentList = this.searchAgent.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                    });
            },
            //getdashboardData(isHideCount = false, isHideAmount = false) {
            //    this.bool_ajaxloading.dashboardDataList = true;
            //    if (isHideCount) {
            //        this.D_Register = '-';
            //        this.setMemberOnline = '-';
            //        this.setMemberOnline_DESKTOP = '-';
            //        this.setMemberOnline_MOBILE = '-';
            //        this.setMemberOnline_ANDROID = '-';
            //        this.setMemberOnline_IOS = '-';
            //        this.D_ActiveMember = '-';
            //        this.D_DailyFirstDeposit = '-';
            //        this.setTotalMember = '-';
            //        this.array_monthlyRS = [];
            //        this.array_dailyRS = [];
            //        this.MTD_Register = '-';
            //        this.L_MTD_Register = '-';
            //        this.D_Deposit = '-';
            //        this.D_Withdraw = '-';
            //        this.Y_Withdraw = '-';
            //        this.Y_Deposit = '-';
            //        this.MTD_Deposit = '-';
            //        this.MTD_Withdraw = '-';
            //        this.L_MTD_Deposit = '-';
            //        this.L_MTD_Withdraw = '-';
            //    }

            //    if (isHideAmount) {
            //        this.AMT_LMTD_Withdraw = '-';
            //        this.AMT_LMTD_Deposit = '-';
            //        this.AMT_MTD_Withdraw = '-';
            //        this.AMT_D_Deposit = '-';
            //        this.AMT_D_Withdraw = '-';
            //        this.AMT_Y_Withdraw = '-';
            //        this.AMT_Y_Deposit = '-';
            //        this.AMT_D_Bonus = '-';
            //        this.AMT_D_AR = '-';
            //        this.AMT_D_DLS = '-';
            //        this.AMT_D_Aff = '-';
            //        this.AMT_D_TNMT = '-';
            //        this.AMT_MTD_Deposit = '-';
            //        this.AMT_Y_Bonus = '-';
            //        this.AMT_MTD_Bonus = '-';
            //        this.AMT_MTD_AR = '-';
            //        this.AMT_MTD_DLS = '-';
            //        this.AMT_MTD_AFF = '-';
            //        this.AMT_MTD_TNMT = '-';
            //        this.AMT_MTD_BonusC = '-';
            //        this.AMT_D_PNL = '-';
            //        this.AMT_Y_PNL = '-';
            //        this.AMT_MTD_PNL = '-';
            //        this.AMT_LMTD_PNL = '-';
            //        this.AMT_LMTD_NPNL = '-';
            //    }

            //    var that = this;
            //    var agi = 0;
            //    //this.CurrencySymbolShow = "";

            //    //If subagent got value, agi = subagent's id, else agent's id
            //    if (this.searchSubAgent != null) {
            //        agi = this.searchSubAgent;
            //    }
            //    else {
            //        if (this.searchAgent != null)
            //            agi = this.searchAgent.split("-")[1];
            //    }

            //    var CI = this.searchCurrency;
            //    var CTCI = this.convertCurrency;

            //    if(CI != null && CTCI == null){
            //        CTCI = CI;
            //    }

            //    var CD = moment().format('YYYY-MM-DD HH:mm:ss');
            //    this.getDataApi(`/api/dc/crc?f[CD]=${CD}&f[AGI]=${agi}&f[CI]=${CI}&f[CTCI]=${CTCI}`,
            //        function (d, s) {
            //            if (s) {
            //                that.bool_ajaxloading.dashboardDataList = false;

            //                that.CurrencySymbolShow = d.CurrencySymbol;
            //                that.D_Register = d.totalDailyRegisteredMember;
            //                var totalOnline = 0;
            //                var totalOnline_DESKTOP = 0;
            //                var totalOnline_MOBILE = 0;
            //                var totalOnline_ANDROID = 0;
            //                var totalOnline_IOS = 0;

            //                for (var i = 0; i < d.totalMemberOnline.length; i++) {
            //                    totalOnline += d.totalMemberOnline[i].TO;
            //                    if (d.totalMemberOnline[i].IM == 0) { totalOnline_DESKTOP += d.totalMemberOnline[i].TO; }
            //                    else if (d.totalMemberOnline[i].IM == 1) { totalOnline_MOBILE += d.totalMemberOnline[i].TO; }
            //                    else if (d.totalMemberOnline[i].IM == 2) { totalOnline_ANDROID += d.totalMemberOnline[i].TO; }
            //                    else if (d.totalMemberOnline[i].IM == 3) { totalOnline_IOS += d.totalMemberOnline[i].TO; }
            //                }
            //                that.top3b = d.Top3B;
            //                that.bottom3b = d.Bottom3B;

            //                that.setMemberOnline_DESKTOP = totalOnline_DESKTOP;
            //                that.setMemberOnline_MOBILE = totalOnline_MOBILE;
            //                that.setMemberOnline_ANDROID = totalOnline_ANDROID;
            //                that.setMemberOnline_IOS = totalOnline_IOS;

            //                that.setMemberOnline = totalOnline;

            //                that.D_ActiveMember = d.totalActiveMember;
            //                that.D_DailyFirstDeposit = d.totalDailyFirstDeposit;
            //                that.setTotalMember = d.totalMember;
            //                that.array_dailyRS = d.dailyRegisterSource;
            //                that.array_monthlyRS = d.MonthlyRegisterSource;
            //                that.CD_ActiveMember = d.CD_ActiveMember;
            //                 //var memtemp = {
            //                 //    name: "Active Member-Count",
            //                 //    data: d.CD_Register
            //                 //}
            //                 //Vue.set(that.series, 2, memtemp)

            //                that.CD_Register = d.CD_Register;
            //                that.MTD_Register = d.totalMonthlyRegisteredMember;
            //                var regtemp = {
            //                    name: "Registered-Count",
            //                    data: that.CD_Register
            //                }
            //                Vue.set(that.series, 1, regtemp)

            //                that.L_MTD_Register = d.totalLastMonthRegisteredMember;

            //                that.SummaryArray = d.getDepositByDay;
            //                that.D_Deposit = 0;
            //                that.AMT_D_Deposit = 0;
            //                var arrL = parseInt(that.SummaryArray.length);
            //                var i = 0;
            //                for (i = 0; i < arrL; i++) {
            //                    that.D_Deposit += that.SummaryArray[i].DC;
            //                    that.AMT_D_Deposit += that.SummaryArray[i].TA;
            //                }

            //                that.SummaryArray = d.getWithdrawByDay;
            //                that.D_Withdraw = 0;
            //                that.AMT_D_Withdraw = 0;
            //                var arrL = parseInt(that.SummaryArray.length);
            //                var i = 0;
            //                for (i = 0; i < arrL; i++) {
            //                    that.D_Withdraw += that.SummaryArray[i].DC;
            //                    that.AMT_D_Withdraw += that.SummaryArray[i].TA;
            //                }

            //                that.SummaryArray = d.getDepositByYesterday;
            //                that.Y_Deposit = 0;
            //                that.AMT_Y_Deposit = 0;
            //                var arrL = parseInt(that.SummaryArray.length);
            //                var i = 0;
            //                for (i = 0; i < arrL; i++) {
            //                    that.Y_Deposit += that.SummaryArray[i].DC;
            //                    that.AMT_Y_Deposit += that.SummaryArray[i].TA;
            //                }

            //                that.SummaryArray = d.getWithdrawByYesterday;
            //                that.Y_Withdraw = 0;
            //                that.AMT_Y_Withdraw = 0;
            //                var arrL = parseInt(that.SummaryArray.length);
            //                var i = 0;
            //                for (i = 0; i < arrL; i++) {
            //                    that.Y_Withdraw += that.SummaryArray[i].DC;
            //                    that.AMT_Y_Withdraw += that.SummaryArray[i].TA;
            //                }

            //                that.SummaryArray = d.getMemberBonusDataByDay;
            //                that.AMT_D_Bonus = 0;
            //                that.AMT_D_AR = 0;
            //                that.AMT_D_DLS = 0;
            //                that.AMT_D_Aff = 0;
            //                that.AMT_D_TNMT = 0;
            //                if (that.SummaryArray) {
            //                    var arrl = that.SummaryArray.length;
            //                    var i = 0;
            //                    for (i = 0; i < arrl; i++) {
            //                        if (that.SummaryArray[i].TT == 1) {
            //                            that.AMT_D_Bonus += that.SummaryArray[i].TBA;

            //                        }
            //                        else if (that.SummaryArray[i].TT == 2) {
            //                            that.AMT_D_AR += that.SummaryArray[i].TBA;
            //                        }
            //                        else if (that.SummaryArray[i].TT == 3) {
            //                            that.AMT_D_DLS += that.SummaryArray[i].TBA;
            //                        }
            //                        else if (that.SummaryArray[i].TT == 4) {
            //                            that.AMT_D_Aff += that.SummaryArray[i].TBA;

            //                        }
            //                        else if (that.SummaryArray[i].TT == 5) {
            //                            that.AMT_D_TNMT += that.SummaryArray[i].TBA;

            //                        }
            //                    }
            //                }

            //                that.SummaryArray = d.getMemberBonusDataByYesterday;
            //                that.AMT_Y_Bonus = 0;
            //                if (that.SummaryArray) {
            //                    var arrl = that.SummaryArray.length;
            //                    var i = 0;
            //                    for (i = 0; i < arrl; i++) {
            //                        that.AMT_Y_Bonus += that.SummaryArray[i].TBA;
            //                    }
            //                }

            //                that.SummaryArray = d.getMemberBonusDataByMonth;
            //                that.AMT_MTD_Bonus = 0;
            //                that.AMT_MTD_AR = 0;
            //                that.AMT_MTD_DLS = 0;
            //                that.AMT_MTD_AFF = 0;
            //                that.AMT_MTD_TNMT = 0;
            //                if (that.SummaryArray) {
            //                    var arrl = that.SummaryArray.length;
            //                    var i = 0;
            //                    for (i = 0; i < arrl; i++) {
            //                        if (that.SummaryArray[i].TT == 1) {
            //                            that.AMT_MTD_Bonus += that.SummaryArray[i].TBA;
            //                        }
            //                        else if (that.SummaryArray[i].TT == 2) {
            //                            that.AMT_MTD_AR += that.SummaryArray[i].TBA;
            //                        }
            //                        else if (that.SummaryArray[i].TT == 3) {
            //                            that.AMT_MTD_DLS += that.SummaryArray[i].TBA;
            //                        }
            //                        else if (that.SummaryArray[i].TT == 4) {
            //                            that.AMT_MTD_AFF += that.SummaryArray[i].TBA;
            //                        }
            //                        else if (that.SummaryArray[i].TT == 5) {
            //                            that.AMT_MTD_TNMT += that.SummaryArray[i].TBA;
            //                        }
            //                    }
            //                }

            //                that.SummaryArray = d.getMemberBonusCappingDataByMonth;
            //                that.AMT_MTD_BonusC = 0;
            //                var arrl = parseInt(that.SummaryArray.length);
            //                var i = 0;
            //                for (i = 0; i < arrl; i++) {
            //                    that.AMT_MTD_BonusC += that.SummaryArray[i].TBA;
            //                }

            //                that.SummaryArray = d.getPNLDataByDay;
            //                that.AMT_D_PNL = 0;
            //                var arrL = parseInt(that.SummaryArray.length);
            //                var i = 0;
            //                for (i = 0; i < arrL; i++) {
            //                    that.AMT_D_PNL -= that.SummaryArray[i].WLA;
            //                }

            //                that.SummaryArray = d.getPNLDataByYesterday;
            //                that.AMT_Y_PNL = 0;
            //                var arrL = parseInt(that.SummaryArray.length);
            //                var i = 0;
            //                for (i = 0; i < arrL; i++) {
            //                    that.AMT_Y_PNL -= that.SummaryArray[i].WLA;
            //                }

            //                that.SummaryArray = d.getPNLDataByMonth;
            //                that.AMT_MTD_PNL = 0;
            //                var arrL = parseInt(that.SummaryArray.length);
            //                var i = 0;
            //                for (i = 0; i < arrL; i++) {
            //                    that.AMT_MTD_PNL -= that.SummaryArray[i].WLA;
            //                }

            //                that.SummaryArray = d.getPNLDataByLastMonth;
            //                var arrL = parseInt(that.SummaryArray.length);
            //                that.AMT_LMTD_PNL = 0;
            //                var i = 0;
            //                for (i = 0; i < arrL; i++) {
            //                    that.AMT_LMTD_PNL -= that.SummaryArray[i].WLA;
            //                }

            //                that.SummaryArray = d.getNPNLDataByLastMonth;
            //                var arrL = parseInt(that.SummaryArray.length);
            //                that.AMT_LMTD_NPNL = 0;
            //                var i = 0;
            //                for (i = 0; i < arrL; i++) {
            //                    that.AMT_LMTD_NPNL += that.SummaryArray[i].TBA;
            //                }

            //                that.SummaryArray = d.getMemberDepositDataByMonthChartS;

            //                that.CD_Deposit = [];
            //                that.CD_DepositMoney = [];
            //                var arrL = parseInt(that.SummaryArray.length);
            //                var i = 0;
            //                for (i = 0; i < arrL; i++) {
            //                    that.CD_Deposit.push(that.SummaryArray[i].DC + '-' + that.SummaryArray[i].TA);

            //                    that.CD_DepositMoney.push(that.SummaryArray[i].TA);
            //                }
            //                var temp = {
            //                    name: "Deposit-Count",
            //                    data: that.CD_Deposit,
            //                }

            //                var temp1 = {
            //                    name: "Deposit-Money",
            //                    data: that.CD_DepositMoney,
            //                }

            //                Vue.set(that.series, 0, temp)
            //                Vue.set(that.chartOptions.savedata, 0, temp1)

            //                that.SummaryArray = d.getMemberDepositDataByMonth;
            //                that.MTD_Deposit = 0;
            //                that.AMT_MTD_Deposit = 0;
            //                var arrL = parseInt(that.SummaryArray.length);
            //                var i = 0;
            //                for (i = 0; i < arrL; i++) {
            //                    that.MTD_Deposit += that.SummaryArray[i].DC;
            //                    that.AMT_MTD_Deposit += that.SummaryArray[i].TA;
            //                }


            //                that.SummaryArray = d.getMemberWithdrawDataByMonth;
            //                that.MTD_Withdraw = 0;
            //                that.AMT_MTD_Withdraw = 0;
            //                var arrL = parseInt(that.SummaryArray.length);
            //                var i = 0;
            //                for (i = 0; i < arrL; i++) {
            //                    that.MTD_Withdraw += that.SummaryArray[i].DC;
            //                    that.AMT_MTD_Withdraw += that.SummaryArray[i].TA;
            //                }

            //                that.SummaryArray = d.getMemberDepositDataByLastMonth;
            //                that.L_MTD_Deposit = 0;
            //                that.AMT_LMTD_Deposit = 0;
            //                that.CD_Deposit = [];
            //                var arrL = parseInt(that.SummaryArray.length);
            //                var i = 0;
            //                for (i = 0; i < arrL; i++) {
            //                    that.CD_Deposit.push(that.SummaryArray[i].DC);
            //                    that.L_MTD_Deposit += that.SummaryArray[i].DC;
            //                    that.AMT_LMTD_Deposit += that.SummaryArray[i].TA;
            //                }

            //                that.SummaryArray = d.getMemberWithdrawDataByLastMonth;
            //                that.L_MTD_Withdraw = 0;
            //                that.AMT_LMTD_Withdraw = 0;
            //                var arrL = parseInt(that.SummaryArray.length);
            //                var i = 0;
            //                for (i = 0; i < arrL; i++) {
            //                    that.L_MTD_Withdraw += that.SummaryArray[i].DC;
            //                    that.AMT_LMTD_Withdraw += that.SummaryArray[i].TA;
            //                }

            //            }
            //            that.bool_fullLoading = false;
            //        });
            //},

            getDateInfo() {
                var that = this;

                this.DB_Month = moment().format('MMMM');
                this.DB_TDay = moment().endOf('month').format('DD');
                this.DB_CDay = moment().format('DD');
                this.DB_DProgress = ((this.DB_CDay * 100) / this.DB_TDay).toFixed(2);
                this.getDataApi(`/api/dc/drdt`,
                    function (d, s) {
                        if (s) {
                            that.DB_DRefresh = moment(d).format("MMM DD, YYYY hh:mm a");
                        }
                    });

                //var dateRange = [];
                //for (var i = 0; i < this.DB_TDay; i++) {
                //    dateRange.push(i + 1);
                //}
                //var temp = {
                //    categories: dateRange
                //}
                //Vue.set(this.chartOptions.xaxis, 0, temp)
                var dateRange = [];
                for (var i = 30; i >= 0; i--) {
                    var date = new Date();
                    date.setDate(date.getDate() - i);
                    dateRange.push(date.getDate().toString());
                }

                this.chartOptions = {
                    ...this.chartOptions, ...{
                        xaxis: {
                            categories: dateRange
                        }
                    }
                }
            },
            getConvertCurrencyList() {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency1 = d.dropdownlist;
                            if (that.dd_currency1.length > 0) {
                                var at = 0;
                                at = that.getUserInfo.AT;
                                if ((that.searchAgent == null && that.bool_firstLogin == false) || (at == 0 && that.bool_firstLogin == false) || (at == 1 && that.bool_firstLogin == false) || (at == 2 && that.bool_firstLogin == false)) {
                                    if (localStorage.getItem('CCUSD') != "") {
                                        for (var i = 0; i < that.dd_currency1.length; i++) {
                                            if (that.dd_currency1[i].id == localStorage.getItem('CCUSD')) {
                                                that.convertCurrency = that.dd_currency1[i].id;
                                                break;
                                            }
                                        }
                                    }
                                    if (that.convertCurrency == null) {
                                        that.convertCurrency = that.dd_currency1[0].id;
                                    }
                                    that.bool_firstLogin = true;
                                }
                            }
                            if (that.searchAgent != null && that.searchCurrency != null && that.bool_firstsearchAgent == false) {
                                that.convertCurrency = null;
                                that.bool_firstsearchAgent = true;
                            }
                            that.AutoUpdate();
                            that.AutoGetUpdate(true, true, true);
                        }
                    });
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            changeCurrency(array_C, cC, sC) {
                var z = "";
                for (var i = 0; i < array_C.length; i++) {
                    if (cC == array_C[i].id && cC != null) {
                        z = array_C[i].label;
                        break;
                    }
                    else if (sC == array_C[i].id && sC != null) {
                        z = array_C[i].label;
                    }
                }
                return z;
            },

            groupMemberOnlineSource(data) {
                this.arry_memberOnlineSource = [];

                var tempOBJ = { RSN: "", TM: 0 }
                for (var i = 0; i < data.length; i++) {
                    if (i == 0) {
                        tempOBJ.RSN = data[i].RSN;
                        tempOBJ.TM = data[i].TO;
                    }
                    else if (data[i - 1].RSN == data[i].RSN) {
                        tempOBJ.TM += data[i].TO;
                    } else if (data[i - 1].RSN != data[i].RSN) {
                        this.arry_memberOnlineSource.push(tempOBJ);
                        tempOBJ = { RSN: "", TM: 0 };
                        tempOBJ.RSN = data[i].RSN;
                        tempOBJ.TM = data[i].TO;
                    }

                    if (i == (data.length - 1)) {
                        this.arry_memberOnlineSource.push(tempOBJ);
                    }
                }

                this.arry_memberOnlineSource = _.orderBy(this.arry_memberOnlineSource, 'TM', 'desc');
            },
            MemberOnline() {
                let routeData = this.$router.resolve({ path: '/M/MO', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            MonthlyRegisterSourcePage(rsn, checkHD) {
                var SD = "";
                var ED = "";
                if (checkHD == 'h') {
                    SD = moment().format('DD MMM YYYY 00:00:00');
                    ED = moment().format('DD MMM YYYY 23:59:59');
                }

                let routeData = this.$router.resolve({ path: '/R/RSR', query: { rsn: rsn, df: SD, dt: ED, agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DailyRegisterSourcePage(rsn) {
                let routeData = this.$router.resolve({ path: '/MS/RS', query: { agi: this.searchAgent, rsn: rsn } });
                window.open(routeData.href, '_blank');
            },
            Gotop3Brand(istop, agentType) {
                var SD = moment().format('DD MMM YYYY 00:00:00');
                var ED = moment().format('DD MMM YYYY 23:59:59');
                if (agentType == 3) {
                    let routeData = this.$router.resolve({ path: '/R/SAGTWL', query: { cur: this.convertCurrency, curf: this.searchCurrency } });
                    window.open(routeData.href, '_blank');
                }
                else {
                    let routeData = this.$router.resolve({ path: '/R/TWLBAG', query: { desc: istop, convert: this.convertCurrency, fcur: this.searchCurrency } });
                    window.open(routeData.href, '_blank');
                }
            },
            DepositedMember() {
                var SD = moment().format('DD MMM YYYY 00:00:00');
                var ED = moment().format('DD MMM YYYY 23:59:59');
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/M/ML', query: { df: SD, dt: ED, agi: agi, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DailyRPage() {
                var SD = moment().format('DD MMM YYYY 00:00:00');
                var ED = moment().format('DD MMM YYYY 23:59:59');
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/M/ML', query: { dRf: SD, dRt: ED, agi: agi, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            MonthlyRPage() {
                var SD = moment().startOf('month').format('DD MMM YYYY 00:00:00');
                var ED = moment().endOf('month').format('DD MMM YYYY 23:59:59');
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/M/ML', query: { dRf: SD, dRt: ED, agi: agi, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            PNLPage() {
                var agi = null;
                var CI = this.searchCurrency;
                var CC = this.getCurrencyCode;
                var CTCI = this.convertCurrency;
                var that = this;

                if (CI == null && CTCI == null) {
                    for (var i = 0; i < that.dd_currency1.length; i++) {
                        if (that.dd_currency1[i].label == CC) {
                            CTCI = that.dd_currency1[i].id;
                            break;
                        }
                    }
                }
                else {
                    CTCI = that.convertCurrency;
                }

                if (that.searchAgent != null) {
                    agi = that.searchAgent.split("-")[1];
                }
                let routeData = that.$router.resolve({ path: '/R/TWL', query: { sagi: that.searchAgent, agi: agi, curf: CI, cur: CTCI } });
                window.open(routeData.href, '_blank');
            },
            DailyDPage() {
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/R/DR2', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DailyBPage() {
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/R/PR', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            MonthlyBPage() {
                var agi = null;
                var SD = moment().startOf('month').format('DD MMM YYYY 00:00:00');
                var ED = moment().endOf('month').format('DD MMM YYYY 23:59:59');
                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/R/PR', query: { pf: SD, pt: ED, agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DailyBrandPage() {
                return;
                var SD = moment().format('DD MMM YYYY 00:00:00');
                var ED = moment().format('DD MMM YYYY 23:59:59');
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/M/ML', query: { dRf: SD, dRt: ED, agi: agi, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },

            DailyAR() {
                let routeData = this.$router.resolve({ path: '/R/LR', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },

            DailyDLS() {
                var SD = moment().format('DD MMM YYYY 00:00:00');
                var ED = moment().format('DD MMM YYYY 23:59:59');
                let routeData = this.$router.resolve({ path: '/R/DLSR', query: { df: SD, dt: ED, agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },

            DailyTNMT() {
                var SD = moment().format('DD MMM YYYY 00:00:00');
                var ED = moment().format('DD MMM YYYY 23:59:59');
                let routeData = this.$router.resolve({ path: '/R/TNMTR', query: { df: SD, dt: ED, agi: this.searchAgent } });
                window.open(routeData.href, '_blank');
            },

            MonthlyDLS() {
                var SD = moment().startOf('month').format('DD MMM YYYY 00:00:00');
                var ED = moment().endOf('month').format('DD MMM YYYY 23:59:59');
                let routeData = this.$router.resolve({ path: '/R/DLSR', query: { df: SD, dt: ED, agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            MonthlyAR() {
                var SD = moment().startOf('month').format('DD MMM YYYY 00:00:00');
                var ED = moment().endOf('month').format('DD MMM YYYY 23:59:59');
                let routeData = this.$router.resolve({ path: '/R/LR', query: { df: SD, dt: ED, agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            MonthlyAFF() {
                let routeData = this.$router.resolve({ path: '/AFF/AFFEL', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            MonthlyTNMT() {
                var SD = moment().startOf('month').format('DD MMM YYYY 00:00:00');
                var ED = moment().endOf('month').format('DD MMM YYYY 23:59:59');
                let routeData = this.$router.resolve({ path: '/R/TNMTR', query: { df: SD, dt: ED, agi: this.searchAgent } });
                window.open(routeData.href, '_blank');
            },
            DailyBCPage() {
                let routeData = this.$router.resolve({ path: '/P/PSE', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DailyWPage() {
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/R/WR2', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            AllMember() {
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/M/ML', query: { agi: agi, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            CalculateBCPercentage(AMT_MTD_Bonus, AMT_MTD_BonusC) {
                if (AMT_MTD_Bonus != '-' && !isNaN(AMT_MTD_Bonus) && AMT_MTD_BonusC != '-' && !isNaN(AMT_MTD_BonusC)) {
                    //calculate bonus claimed percentage
                    if (AMT_MTD_BonusC != 0) {
                        var z = (AMT_MTD_Bonus / AMT_MTD_BonusC) * 100;
                    }
                    else if (AMT_MTD_Bonus == 0 && AMT_MTD_BonusC == 0) {
                        z = 0;
                    }
                    else {
                        z = 100;
                    }
                    if (z > 100) {
                        z = 100;
                    }
                    else if (z < -100) {
                        z = -100;
                    }
                    return z;
                } else {
                    return '-';
                }

            },
            countPercentage(daily, yesterday) {
                if (daily != '-' && !isNaN(daily) && yesterday != '-' && !isNaN(yesterday)) {
                    //Calculate count increase or decrease percentage
                    if (yesterday != 0) {
                        var z = ((daily - yesterday) / Math.abs(yesterday)) * 100;
                    }
                    else {
                        z = (daily - yesterday) * 100;
                    }
                    if (z > 100) {
                        z = 100;
                    }
                    else if (z < -100) {
                        z = -100;
                    }
                    return z;
                } else {
                    return '-';
                }
            },
            Compare_YD(today, yesterday) {
                var result = 0;
                result = today - yesterday;
                return result;

            },
            countMoneyPercentage(daily, yesterday) {
                //Calculate Money increase or decrease percentage
                if (yesterday != 0) {
                    var z = ((daily - yesterday) / Math.abs(yesterday)) * 100;
                }
                else {
                    z = (daily - yesterday);
                }
                if (z > 100) {
                    z = 100;
                }
                else if (z < -100) {
                    z = -100;
                }
                return z;
            },
            countTotalNPNL(TotalWL, TotalBC) {
                var netProfit = parseFloat(TotalWL) - parseFloat(TotalBC);
                return netProfit;
            },
            toggleFingPrintId(data, aRow, bRow) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.UBI;
                path += "&f[FPJI]=" + data.SI;
                path += "&f[AGI]=" + data.AGI;

                const index = that.opened.indexOf(aRow + '_' + bRow);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsiu/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_visitorMembers[aRow + '_' + bRow] = d.D.Items;
                                that.opened.push(aRow + '_' + bRow)
                            }
                        });
                }
            },
            getSystemId(data) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.MI;

                const index = that.opened.indexOf(data.I);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsi/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_systemId[data.I] = d.D.Items;
                                that.opened.push(data.I)
                            }
                        });
                }
                this.resizeTableHead()
            },
            AutoUpdate() {
                this.nextUpdate();
                var that = this;
                this.AutoUpdateTO = setTimeout(function () {
                    that.AutoUpdate();
                }, 10000);
            },
            AutoGetUpdate(isHideCount = false, isHideAmount = false, isLoading = false) {
                this.nextGetUpdate(isHideCount, isHideAmount, isLoading);
                //this.bool_ajaxloading.userActivityList = false;
                var that = this;
                this.AutoGetUpdateTO = setTimeout(function () {
                    that.AutoGetUpdate();
                }, 60000);
            },
            nextUpdate: function (isLoading = false) {
                this.getUserActivityList();
            },
            nextGetUpdate: function (isHideCount = false, isHideAmount = false, isLoading = false) {
                if (isLoading) {
                    this.bool_fullLoading = true;
                }
                this.nextUpdate(isLoading);
                this.resizeTableHead();
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        if (!headerCells[index]) return;  // Add a safety check to avoid undefined errors

                        const headerWidth = headerCells[index].getBoundingClientRect().width;
                        const bodyWidth = cell.getBoundingClientRect().width;
                        const width = `${Math.max(bodyWidth, headerWidth)}px`;

                        headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },

            toggleDashboardMonitoringList(ev) {
                this.bool_showDashboardMonitoring = !this.bool_showDashboardMonitoring;

                //// expand dashboard monitoring
                if (this.bool_showDashboardMonitoring) {
                    this.getUserActivityList(true, true);
                }
                //// collapse dashboard monitoring
                else {

                }
            },
            setCollapseExpandIcon() {
                if (this.bool_showDashboardMonitoring) {
                    return "chevron-container chevron-up";
                }
                else {
                    return "chevron-container";
                }
            },
            renderClassName(header, data) {
                if (header == 'U' || header == 'AC') {
                    return "kema-eft";
                }
            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
        },
        beforeRouteLeave(to, from, next) {
            clearTimeout(this.AutoUpdateTO);
            clearTimeout(this.AutoGetUpdateTO);
            next();
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'DASH';
            this.$parent.showActiveMenu = 'DASH.DMMAL';
            this.View_acce = this.checkModuleAccess('DMMAL', 'DASH', constAccessType.view);
            this.str_loadText = this.getLanguage["GL"]["LD"];
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            if (this.$route.query.ssa) {
                this.searchSubAgent = this.$route.query.ssa;
            }
            if (this.$route.query.sa) {
                this.searchAgent = this.$route.query.sa;
            }
            if (this.$route.query.sc) {
                this.searchCurrency = this.$route.query.sc;
            }
        },
        mounted() {
            this.getDateInfo();

            if (this.getUserInfo.AT == 4) {
                this.loadDefaultSubBrand(0);
            }

            this.getAgentGroup();
            this.getCurrencyList();
            this.getConvertCurrencyList();
            this.dd_activityType = [{ id: 1, label: this.getLanguage["DB"]["T1"] }, { id: 2, label: this.getLanguage["DB"]["T2"] }, { id: 3, label: this.getLanguage["DB"]["T3"] }];
        },
        watch: {
            getLanguage() {
                this.getUserActivityList();
                this.dd_activityType = [{ id: 1, label: this.getLanguage["DB"]["T1"] }, { id: 2, label: this.getLanguage["DB"]["T2"] }, { id: 3, label: this.getLanguage["DB"]["T3"] }];
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/MemberActivitiesList`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/MemberActivitiesList/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        }
    }

</script>

<style>
    h6.title-db, h5.title-db {
        height: 30px;
    }

    .plus-button {
        border: 2px solid #a3a3a3;
        background-color: #a3a3a3;
        font-size: 16px;
        height: 2em;
        width: 2em;
        border-radius: 999px;
        position: relative;
        float: right;
    }

        .plus-button:after, .plus-button:before {
            content: "";
            display: block;
            background-color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .plus-button:before {
            height: 1em;
            width: 0.2em;
        }

        .plus-button:after {
            height: 0.2em;
            width: 1em;
        }

    .plus-button--small {
        font-size: 12px;
    }

    table.loading tbody {
        position: relative;
    }

        table.loading tbody:after {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.3);
            background-image: url(data:image/gif;base64,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);
            background-position: center;
            background-repeat: no-repeat;
            background-size: 50px 50px;
            content: "";
        }

    .theme-cicle-title {
        display: flex;
        align-items: center;
    }

    .text-grey {
        color: #808080;
    }

    .text-top3 {
        color: #2C772C;
    }

    .text-bottom3 {
        color: rgb(229, 54, 54) !important;
    }

    .apexcharts-text tspan {
        font-weight: 700;
    }
</style>



// WEBPACK FOOTER //
// src/components/MemberActivitiesList.vue